// extracted by mini-css-extract-plugin
module.exports = {"ImageZoom":"ImageZoom_ImageZoom__1PuYH","Image":"ImageZoom_Image__2lsm0"};